/**
 * Admin console layout.
 *
 * Top bar: product name, operator role badge (from useAdminRole()), sign-out.
 * Left sidebar: the two v1 destinations (Lookup, Admin Actions). The role
 * shown here is presentation only — the backend enforces it on every request.
 */
import { Outlet } from 'react-router-dom';
import { AdminSidebar } from '@/components/navigation/AdminSidebar';
import { AdminTopBar } from '@/components/navigation/AdminTopBar';

export function AdminLayout() {
  return (
    <div className="flex min-h-screen bg-background">
      <AdminSidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <AdminTopBar />
        <main className="flex-1">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
